export default {"src":"/_next/static/media/ion.f0a0538b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};